import React from 'react'

const ManageDomainOrders = () => {
  return (
    <div>
      manage domain orders
    </div>
  )
}

export default ManageDomainOrders
